import { Component, OnInit } from '@angular/core';
import { AnimationItem } from 'lottie-web';
import { AnimationOptions } from 'ngx-lottie';

import {
  trigger,
  state,
  style,
  animate,
  transition,
  // ...
} from '@angular/animations';
import { FormControl } from '@angular/forms';
import { SendEmailService, Contact } from '../send-email.service';
import { DataStoreService } from '../data-store.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-hover-menu',
  templateUrl: './hover-menu.component.html',
  styleUrls: ['./hover-menu.component.scss'],
  animations: [
    trigger('openClose', [
      // ...
      state('open', style({
        height: '100%',
        opacity: 1,
        'z-index': 500
      })),
      state('closed', style({
        height: '0px',
        opacity: 0,
        'z-index': 1
      })),
      transition('open => closed', [
        animate('0.25s ease-out')
      ]),
      transition('closed => open', [
        animate('0.3s ease-out')
      ]),
    ]),
    trigger('activeForm', [
      state('active', style({
        width: '25rem',
        overflow: 'hidden'

      })),
      state('unActive', style({
        width: '0rem',
        overflow: 'hidden',
      })),
      state('full', style({
        
      })),
      transition('active => unActive', [
        animate('0.3s ease-out')
      ]),
      transition('unActive => active', [
        animate('0.3s ease-out')
      ]),

    ])
  ],
})
export class HoverMenuComponent implements OnInit {


  ico1: AnimationOptions = {
    path: '../assets/animations/guarantee.json'
  };
  ico2: AnimationOptions = {
    path: '../assets/animations/map-marker.json'
  };
  ico3: AnimationOptions = {
    path: '../assets/animations/book.json'
  };
  arrow: AnimationOptions = {
    path: '../assets/animations/arrowWhite.json'
  };

  rcContact = {targa: "", contatto: ""}

  activeIndex = 0;

  isOpen = true;

  targaBool = true;
  contactBool = false;
  showEnd = false;

  targa = new FormControl('');
  contact = new FormControl('');
 

  constructor(
    private sendEmail: SendEmailService,
    private dataStore: DataStoreService,
    private router: Router
  ) { }

  ngOnInit() {
  }

  toggle() {
    this.isOpen = !this.isOpen;
  }

  switchForm() {
   this.targaBool = false;
   this.contactBool = true;
  }

  submitTarga() {
   if (this.targaBool) {
    this.rcContact.targa = this.targa.value;
    console.log(this.targa.value);
    this.switchForm();
   } else {
    this.rcContact.contatto = this.contact.value;
    this.contactBool = false;
    this.showEnd = true;
    const contact = new Contact();
     
      contact.email = this.rcContact.contatto;
      contact.targa = this.rcContact.targa;
      contact.type = "RCauto";
      
    this.sendEmail.sendEmail(contact);
   
   }   
  }
  animationCreated(event) {
    console.log(event);
  }


  goToContact(preText: string) {
   this.dataStore.updateText(preText);
   this.router.navigate(['/contatti']).then();
  }

}
